'use client'

import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

export default function HeroUI() {
  const containerRef = useRef<HTMLDivElement>(null)

  useGSAP(
    () => {
      gsap.fromTo('.hero-eyebrow',
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }
      )
      gsap.fromTo('.hero-title',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1.2, delay: 0.15, ease: 'power3.out' }
      )
      gsap.fromTo('.hero-sub',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, delay: 0.4, ease: 'power3.out' }
      )
      gsap.fromTo('.hero-cta',
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, delay: 0.65, ease: 'power3.out' }
      )
    },
    { scope: containerRef }
  )

  return (
    <div
      ref={containerRef}
      className="flex flex-col justify-center items-center px-6 md:px-10 lg:px-8 xl:px-10 pointer-events-none"
    >
      <div className="relative z-10 w-[26rem] max-w-full text-center">

        <p className="hero-eyebrow text-[11px] font-bold tracking-[0.3em] uppercase text-coldwing-accent mb-5">
          Engineering · Design · Innovation
        </p>

        <h1 className="hero-title text-[3.75rem] leading-[1.05] font-semibold tracking-tighter text-coldwing-dark">
          Digital Engineering
          <br />
          &amp; Immersive Design
        </h1>

        <div className="hero-sub mt-8 pt-5 border-t-2 border-coldwing-accent">
          <p className="text-base leading-relaxed text-coldwing-dark/65">
            Building the next generation of digital experiences at the
            intersection of technology and design. Performance-first
            engineering meets world-class creative direction.
          </p>
        </div>

        <div className="hero-cta mt-10 flex justify-center pointer-events-auto">
          <button className="bg-coldwing-accent text-coldwing-dark px-8 py-4 text-xs font-bold tracking-[0.18em] uppercase hover:bg-coldwing-dark hover:text-white transition-colors duration-300 cursor-pointer">
            Explore Our Work
          </button>
        </div>

      </div>
    </div>
  )
}
